import styled from "styled-components";

export const Main = styled.nav`
   position: relative;
   display: flex;
   flex-direction: column;
   min-width: 390px;
   width: 390px;
   height: 100vh;
   background-image: linear-gradient( to bottom right, #0f172a, #1e293b, #0f172a);
   transition: min-width 0.5s ease-in-out, width 0.5s ease-in-out;

   &.minimizeMenu {
      min-width: 85px;
      width: 85px;

      .logo {
         display: flex;
         justify-content: center;
         width: 100%;
         margin-bottom: 10px;
         padding-left: 12px;
         padding-right: 14px;
      }
      .mini {
         width: 100%;
      }
      .search {
         padding-left: 10px;
         svg {
            left: 34px;
         }
      }
   }
   .logo {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      margin: 25px 0 20px;
      padding: 0 15px;
      transition: all .2s ease-in-out;

      .title {
         display: flex;
         align-items: center;
         cursor: default;

         .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 45px;
            width: 45px;
            height: 45px;
            box-shadow: 0 20px 25px -5px rgba(59, 130, 246, 0.2), 0 8px 10px -6px rgba(59, 130, 246, 0.2);
            background-image: linear-gradient(to bottom right, #3b82f6, #06b6d4, #2563eb);
            border-radius: 15px;
            margin-right: 15px;
         }
         .info {
            white-space: nowrap;

            span {
               font-size: 13px;
               color: rgb(148, 163, 184);
               font-weight: 500;
            }
         }
      }
      .mini {
         display: flex;
         align-items: center;
         justify-content: center;
         padding: 7px;
         cursor: pointer;
         transition: all .2s ease-in-out;
         color: rgb(148, 163, 184);
         border: 1px solid rgb(71, 85, 105);
         border-radius: 7.5px;

         &:hover {
            background-color: rgba(51, 65, 85, 1);
         }
      }
   }
   .search {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0 15px;
      color: #fff;
      
      input {
         width: 100%;
         height: 35px;
         border-radius: 10px;
         border: 1px solid rgba(71, 85, 105, 0.5);
         background-color: rgba(30, 41, 59, 0.6);
         padding: 0 15px 0 45px;
         color: #ddd;
         font-size: 14px;

         &::placeholder {
            color: #fff;
            opacity: 0.4;
         }
         &::-webkit-search-cancel-button,
         &::-webkit-search-decoration,
         &::-webkit-search-results-button,
         &::-webkit-search-results-decoration {
            display: none;
         }
      }
      svg {
         position: absolute;
         left: 30px;
         opacity: 0.4;
         font-size: 16px;
         transition: all .2s linear;
      }
   }
   .categories {
      display: flex;
      margin-top: 15px;
      height: 100%;
      
      ul:first-of-type {
         display: flex;
         flex-direction: column;
         align-items: center;
         width: 85px;
         min-width: 85px;
         height: 100%;         
         border: 1px solid rgba(51, 65, 85, 0.3);  
         border-left: none;
         border-bottom: none;

         li {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #fff;
            font-size: 14px;
            cursor: pointer;
            transition: all .2s ease-in-out;
            width: 100%;
            padding: 10px 0;
            border-radius: 5px;

            img {
               width: 35px;
               height: 35px;
               object-fit: contain;
               margin-bottom: 2.5px;
            }
            &.active {
               box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
               background-image: linear-gradient(to bottom right, #06b6d4, #3b82f6);
            }
            &:hover {
               background-color: rgba(30, 41, 59, 0.6);
            }
            /* &.fetch {
               &.active {
                  background-image: linear-gradient(to bottom right, #06b6d4, #3b82f6);
               }
            }
            &.process {
               &.active {
                  background-image: linear-gradient(to bottom right, #a855f7, #ec4899);
               }
            }
            &.actions {
               &.active {
                  background-image: linear-gradient(to bottom right, #22c55e, #10b981);
               }
            }
            &.templates {
               &.active {
                  background-image: linear-gradient(to bottom right, #f97316, #ef4444);
               }
            } */
         }
      }
      .blocks {
         width: 100%;
         height: 100%;
         border-top: 1px solid #28343e;  
         color: #ccc;

         .container {
            margin: 15px;
            height: calc(100vh - 65px - 20px - 35px - 15px - 30px);
            overflow: auto;

            &::-webkit-scrollbar {
               width: 0;
            }
         }
      }
      .items {
         width: 275px;

         &.searchFilter {
            padding: 10px;
            color: #ccc;
            overflow: auto;
            width: 100%;

            &::-webkit-scrollbar {
               width: 0;
            }
            > div {
               justify-content: center;

               > div:nth-of-type(2n) {
                  margin-right: 15px;
               }
               > div:nth-of-type(3n) {
                  margin-right: 0;
               }
            }
         }
         &.noWrap {
            opacity: 0.65;
         }
         &:not(:last-of-type) {
            margin-bottom: 15px;
         }
         .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
            
            h4 {
               color: rgb(226, 232, 240);
               white-space: nowrap;
               font-size: 17px;
            }
            span {
               font-size: 16px;
               color: rgb(148, 163, 184);
               cursor: pointer;
               transition: all .2s ease-in-out;
               
               &:hover {
                  opacity: 1;
               }
            }
         }
         > div {
            display: flex;
            flex-wrap: wrap;

            > div {
               display: flex;
               flex-direction: column;
               align-items: center;
               justify-content: center;
               margin-bottom: 15px;
               margin-right: 15px;
               transition: all .2s ease-in-out;
               width: 81.6px;
               padding: 15px 15px 10px;
               border: 1px solid rgba(51, 65, 85, 0.3); 
               border-radius: 15px;

               &:nth-of-type(3n) {
                  margin-right: 0;
               }
               .otherSvg {
                  width: 25px;
                  height: 25px;

                  svg {
                     fill: #fff;
                     position: relative;
                     path { fill: #fff; }
                  }
               }
               svg {
                  width: 25px;
                  height: 25px;
                  color: #fff;
               }
               > span:first-of-type {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: #06b6d4;
                  border-radius: 5px;
                  width: 40px;
                  height: 40px;
               }
               > span:last-of-type {
                  margin-top: 7.5px;
                  text-align: center;
                  font-size: 13px;
               }
               &:hover {
                  opacity: 0.75;
                  cursor: move;
               }
            }
         }
      }
   }
`; 